import React from "react";
import { MarcasItemDetalle } from "./MarcasItemDetalle";

function MarcasItem(props) {
  const displayItems = (props) => {
    if (props) {
      const marcas = props.marcas

      if (marcas) {
        if (marcas.length > 0) {
          return marcas.map((marca, index) => {
            return (
              <MarcasItemDetalle key={index} marca={marca} deleteMarca={props.deleteMarca} />
            )
          })
        } else {
          return <h3>No hay marcas</h3>
        }
      } else {
        return <h3>No hay marcas</h3>
      }
    } else {
      return <h3>No hay marcas</h3>
    }
  }

  return <>{displayItems(props)}</>
}

export {MarcasItem}